import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';
import { formatPhoneNumber } from 'src/utils/phone';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
    root: {},
    marginBottom: {
        marginBottom: 20
    },
    divider: {
        marginBottom: 20,
        marginTop: 20
    },
    gridOverflow: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '6px !important'
    }
}));

const ContactSummary = ({ emailAddress, contactName, phoneNumber }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Grid container>
            <Grid item xs={4} className={classes.gridOverflow}>
                <Typography noWrap variant="h5" color="textPrimary">
                    {emailAddress}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {t('glassClaim.contact.email')}
                </Typography>
            </Grid>
            <Grid item xs={4} className={classes.gridOverflow}>
                <Typography noWrap variant="h5" color="textPrimary">
                    {contactName}
                </Typography>
                <Typography noWrap variant="body2" color="textSecondary">
                    {t('glassClaim.contact.name')}
                </Typography>
            </Grid>
            <Grid item xs={4} className={classes.gridOverflow}>
                <Typography noWrap variant="h5" color="textPrimary" align="right">
                    {phoneNumber ? formatPhoneNumber(phoneNumber) : ''}
                </Typography>
                <Typography noWrap variant="body2" color="textSecondary" align="right">
                    {t('glassClaim.contact.phone')}
                </Typography>
            </Grid>
        </Grid>

    );
};

ContactSummary.propTypes = {
    emailAddress: PropTypes.string,
    contactName: PropTypes.string,
    phoneNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ContactSummary;
